import {initElements} from "../define/shared"

export default function initAgePrepage() {
    initElements(".agePrepage", layout => {
        const buttons = {
            yes: layout.querySelector('[data-action="yes"]'),
            no: layout.querySelector('[data-action="no"]')
        }
        const text = {
            first: layout.querySelector('[data-text="first"]'),
            no: layout.querySelector('[data-text="no"]')
        }

        buttons.no.addEventListener('click', () => {
            text.no.style.display = 'block'
            text.first.style.display = 'none'
        })

        buttons.yes.addEventListener('click', () => {
            const expiryDate = new Date();
            expiryDate.setDate(expiryDate.getDate() + 30);
            document.cookie = 'age_is_verified=yes; expires='+ expiryDate.toUTCString() +'; path=/'
            layout.remove()
        })
    })
}
